import {Component} from "react";
import Manutencao from "../../_elementos/manutencao/Manutencao";

export default class ErrorBoundary extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            error: null,
            hasError: false
        };
    }

    static getDerivedStateFromError(error: any) {
        return {error, hasError: true};
    }

    render() {
        const {error, hasError} = this.state;
        if (hasError)
            return <Manutencao 
                titulo="Algo deu errado." 
                mensagem={error?.message || error || 'Esta parte do sistema está temporariamente indisponível. Por favor, tente novamente mais tarde.'} 
            />;
        return this.props.children;
    }

}